import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./style.css";

class Hero extends Component {
  render() {
    var settings = {
      dots: false,
      arrows: true,
      speed: 1200,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2500,
      fade: true,
    };

    return (
      <section id="hero" className="hero hero-slider hero-style-1">
        <Slider {...settings}>
          <div className="slide">
            <div
              className="slide-inner"
              style={{
                backgroundImage: `url(${this.props.Hero})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundAttachment: "fixed",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                backgroundBlendMode: "overlay",
              }}
            >
              <div className="container">
                <div className="col col-lg-6 slide-caption">
                  <div className="slide-title">
                    <h2>
                      لنكن <span>لطفاء</span>
                    </h2>
                  </div>
                  <div className="slide-subtitle">
                    <p>فباللطف ترتقي المجتمعات وتسمو القيم</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </section>
    );
  }
}

export default Hero;
